import React, { memo, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import { SearchNormal1 } from "iconsax-react";

import InputComponent from "../form/input";
import ButtonComponent from "../button";

import { StyledSearchForm } from "./styledSearch";

const SearchBar = ({
  params,
  loading,
  runAxios,
  showAllItems,
  setShowAllItems,
}) => {
  const history = useHistory();
  const {
    register,
    reset,
    handleSubmit,
    formState: { isValid },
  } = useForm({ mode: "onChange" });

  const queryParams = params.get("q");

  useEffect(() => {
    history.listen((obj) => {
      if (!obj.search.includes("q")) {
        reset();
      }
    });
  }, []);

  const handleSubmitSearch = (formValue) => {
    if (showAllItems) setShowAllItems(false);
    history.push({
      search: `q=${formValue.search_input}`,
    });
    runAxios.searchRun({ q: formValue.search_input, limit: 12 }).then(() => {
      runAxios.filterCategoriesRun(undefined, {
        q: formValue.search_input,
      });
    });
  };

  return (
    <StyledSearchForm
      className="w-100 px-2 py-1"
      onSubmit={handleSubmit(handleSubmitSearch)}
    >
      <SearchNormal1 size="25" color="var(--dark-color)" />
      <InputComponent
        defaultValue={queryParams}
        register={register("search_input", {
          required: true,
        })}
        containerClass="search-input"
        placeholder="دنبال چی میگردی؟"
      />
      <ButtonComponent disabled={!isValid} type="submit">
        {loading.searchResultLoading || loading.filterCategoriesLoading ? (
          <Spinner
            as="span"
            animation="border"
            role="status"
            aria-hidden="true"
          />
        ) : (
          "جستجو کن"
        )}
      </ButtonComponent>
    </StyledSearchForm>
  );
};

export default memo(SearchBar);
